import Vue from 'vue';
import { get, sync } from 'vuex-pathify';
import { mapActions, mapMutations } from 'vuex';
import { isEmptyObject } from '@/utils/helpers';
import { Event } from '@/models/Event';

export default Vue.extend({
  name: 'event-callable',

  data: () => ({}),
  computed: {
    eventLoading: get('event/getEventLoading'),
    getError: get('event/getEventError'),
    eventList: get<Event[]>('event/getEventList'),
    demoEvent: get<Event>('event/demoEvent'),
    getCurrentEvent: sync<string>('event/currentEvent'),
    // eventInstance: get('event/getEventInstance'),
    eventOptions: get('event/getEventOptions'),
    getEventById: get<Event | any>('event/getEventById')
  },
  methods: {
    ...mapActions({
      createEvent: 'event/createEvent',
      fetchEvents: 'event/fetchEvents',
      updateEvent: 'event/updateEvent',
      fetchEvent: 'event/fetchEvent',
      optionsEvent: 'event/optionsEvent',
      clearError: 'error/clearError',
      createSnack: 'snackbar/createSnack'
    }),
    ...mapMutations({
      SET_CURRENT_EVENT: 'event/SET_CURRENT_EVENT'
    }),
    isEmptyObject
  }
});
